export const VimeoIcon = ({ className }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    width="64"
    height="64"
    shapeRendering="geometricPrecision"
    textRendering="geometricPrecision"
    imageRendering="optimizeQuality"
    fillRule="evenodd"
    clipRule="evenodd"
    viewBox="0 0 640 640"
  >
    <path d="M639.764 171.144c-2.894 62.257-46.383 147.675-130.537 255.901-87.025 113.021-160.667 169.679-220.916 169.679-37.229 0-68.87-34.37-94.643-103.265-17.232-63.13-34.37-126.261-51.65-189.368-19.122-68.894-39.65-103.265-61.643-103.265-4.771 0-21.52 10.122-50.244 30.119L0 192.18a7751.179 7751.179 0 0 0 93.378-83.257c42.12-36.366 73.773-55.489 94.891-57.532 49.76-4.76 80.54 29.245 91.998 102.143 12.366 78.65 21 127.537 25.89 146.671 14.362 65.233 30.118 97.88 47.374 97.88 13.359 0 33.52-21.13 60.379-63.545 26.752-42.236 41.127-74.481 43.123-96.639 3.885-36.484-10.489-54.886-43.123-54.886-15.366 0-31.122 3.52-47.375 10.524 31.477-103.017 91.49-153.014 180.262-150.144 65.659 1.748 96.651 44.362 92.907 127.785l.06-.036z" />
  </svg>
);
